/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components

// @mui material components
import Card from "@mui/material/Card";


// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";

// Authentication layout components
import CoverLayout from "components/layouts/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import RegisterForm from "dashboard/examples/Forms/Users/RegisterForm";

function Cover() {
  return (
    <CoverLayout image={bgImage} coverHeight="45vh" lg={3.1} rest>
      <Card>
      <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Rejoignez-nous aujourd'hui
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Entrez votre email et votre mot de passe pour vous inscrire
          </MDTypography>
        </MDBox>
        <MDBox  pt={4} pb={3} px={3}>
          <RegisterForm/>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
